import { apiClient } from '@/api/client';
import type {
  EligibleExperiencesResponseWire,
  GuidedExperienceStateWire,
} from '../schemas/guided-experience';

export async function getEligibleExperiences(): Promise<EligibleExperiencesResponseWire> {
  return apiClient.get<EligibleExperiencesResponseWire>('/api/v1/guided-experiences/eligible');
}

export async function getExperienceState(experienceId: string): Promise<GuidedExperienceStateWire> {
  return apiClient.get<GuidedExperienceStateWire>(
    `/api/v1/guided-experiences/${experienceId}/state`
  );
}

export async function startExperience(
  experienceId: string,
  version?: number
): Promise<GuidedExperienceStateWire> {
  return apiClient.post<GuidedExperienceStateWire>(
    `/api/v1/guided-experiences/${experienceId}/start`,
    version !== undefined ? { experience_version: version } : {}
  );
}

export async function updateExperienceState(
  experienceId: string,
  data: { current_step?: number; payload?: string }
): Promise<GuidedExperienceStateWire> {
  return apiClient.patch<GuidedExperienceStateWire>(
    `/api/v1/guided-experiences/${experienceId}/state`,
    data
  );
}

export async function dismissExperience(
  experienceId: string
): Promise<GuidedExperienceStateWire> {
  return apiClient.post<GuidedExperienceStateWire>(
    `/api/v1/guided-experiences/${experienceId}/dismiss`,
    {}
  );
}

export async function completeExperience(
  experienceId: string
): Promise<GuidedExperienceStateWire> {
  return apiClient.post<GuidedExperienceStateWire>(
    `/api/v1/guided-experiences/${experienceId}/complete`,
    {}
  );
}
